import { Component } from 'preact'
import $ from 'jquery'
import ButtonControl from '../button-control'

class WebmasterSetup extends Component {
  constructor (props) {
    super()
    this.state = { email: props.webmaster.length > 0 ? props.webmaster[0] : '', name: props.name, loading: false }
    this.csrfToken = document.getElementById('csrftoken').value
  }

  setWebmaster () {
    this.setState({ loading: true })
    $.post(
      '/settings/emailManagement/saveWebmaster',
      { email: this.state.email, name: this.state.name, yip_csrf_token: this.csrfToken }
    ).fail(function () {
      this.setState({ loading: false })
    }.bind(this)).then(function () {
      this.setState({ loading: false })
      window.location.reload()
    }.bind(this))
  }

  render (props, state) {
    return props.emails.length > 0 ? <WebmasterComponent
      {...props}
      {...state}
      onChangeMail={(val) => this.setState({ email: val })}
      onChangeName={(val) => this.setState({ name: val })}
      setWebmaster={() => this.setWebmaster()}
    /> : null
  }
}

const WebmasterComponent = (props) => <div class='email-setup'>
  <h3>Email Setup</h3>

  <div class='form'>
    <div class='row'>
      <label for='webmaster'>Webmaster Email:</label>
      <input type='text' placeholder='eg: Insided Community' value={props.name} onChange={(e) => props.onChangeName(e.target.value)} />
      <select class='webmasterSelector' onChange={(e) => props.onChangeMail(e.target.value)}>
        <option disabled selected={props.webmaster.length === 0}>Select your option</option>
        { props.emails.map(email => <option selected={props.webmaster.length > 0 && email === props.webmaster[0]}>{email}</option>) }
      </select>
      <ButtonControl variant='success' title='Save' isLoading={props.loading} onClick={props.setWebmaster} />
    </div>
  </div>
</div>

export { WebmasterComponent }
export default WebmasterSetup
